document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('#modal-menu')
  const openBtn = document.querySelector('.open-btn')
  const closeBtn = document.querySelector('.close-btn')

  if (modal && openBtn && closeBtn) {
    // Écouter les événements d'ouverture et de fermeture de la modal
    modal.addEventListener('show.bs.modal', function () {
      openBtn.style.display = 'none' // Cacher le bouton "open-btn"
      closeBtn.style.display = 'flex' // Afficher le bouton "close-btn"
    })

    modal.addEventListener('hidden.bs.modal', function () {
      openBtn.style.display = 'flex' // Afficher le bouton "open-btn"
      closeBtn.style.display = 'none' // Cacher le bouton "close-btn"
    })
  }
})
